import { render, staticRenderFns } from "./OwnClass.vue?vue&type=template&id=4f936376"
import script from "./OwnClass.vue?vue&type=script&lang=js"
export * from "./OwnClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports